var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (classes) {
buf.push("<div" + (jade.cls(['u-m4x',classes], [null,true])) + ">PaperRank is a function of the number of recommendations a paper has\nreceived, weighted by the AuthorRanks of the recommenders. AuthorRank\nis a function of the PaperRanks of the papers on the author’s profile.</div>");}.call(this,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined));;return buf.join("");
}